"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Collapsible = function Collapsible(_ref) {
  var id = _ref.id,
    isOpen = _ref.isOpen,
    children = _ref.children,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_styled.Section, {
    id: id,
    key: id,
    className: "".concat(className, "-container"),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_styled.BodySection, {
    className: className,
    isOpen: isOpen
  }, children));
};
Collapsible.propTypes = {
  onClick: _propTypes.default.func,
  id: _propTypes.default.string.isRequired,
  className: _propTypes.default.string.isRequired,
  isOpen: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};
Collapsible.defaultProps = {
  isOpen: false,
  onClick: _noop.default
};
var _default = Collapsible;
exports.default = _default;